/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGetCustomerBalanceRequest
 */
export interface InvoiceGetCustomerBalanceRequest {
    /**
     * 
     * @type {number}
     * @memberof InvoiceGetCustomerBalanceRequest
     */
    customerId?: number;
}

/**
 * Check if a given object implements the InvoiceGetCustomerBalanceRequest interface.
 */
export function instanceOfInvoiceGetCustomerBalanceRequest(value: object): value is InvoiceGetCustomerBalanceRequest {
    return true;
}

export function InvoiceGetCustomerBalanceRequestFromJSON(json: any): InvoiceGetCustomerBalanceRequest {
    return InvoiceGetCustomerBalanceRequestFromJSONTyped(json, false);
}

export function InvoiceGetCustomerBalanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGetCustomerBalanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
    };
}

export function InvoiceGetCustomerBalanceRequestToJSON(json: any): InvoiceGetCustomerBalanceRequest {
    return InvoiceGetCustomerBalanceRequestToJSONTyped(json, false);
}

export function InvoiceGetCustomerBalanceRequestToJSONTyped(value?: InvoiceGetCustomerBalanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerId': value['customerId'],
    };
}

